import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';

import {
  InsightsEvent,
  InsightsEventProperties,
  InsightsEventsTrackingService,
  getFeatureNameFromAppTitle,
} from '@core/shared/util';
import { InsightsOrganizationInfoService } from '@mp/shared/app-insights/util';

import { AppInsightsService } from './app-insights.service';

@Injectable()
export class AppInsightsFacade implements InsightsEventsTrackingService {
  private readonly appInsightsService: AppInsightsService = inject(AppInsightsService);
  private readonly titleService: Title = inject(Title);
  private readonly insightsOrganizationInfoService: InsightsOrganizationInfoService = inject(
    InsightsOrganizationInfoService,
  );

  trackEvent(event: InsightsEvent, customProperties: InsightsEventProperties = {}, includePageName = true): void {
    const eventName = includePageName ? this.addPageNameToEvent(event) : event;

    const organizationName: string | null = this.insightsOrganizationInfoService.organizationName();
    if (organizationName) {
      customProperties = { ...customProperties, organizationName };
    }

    this.appInsightsService.trackEvent(eventName, customProperties);
  }

  private addPageNameToEvent(event: InsightsEvent): string {
    const currentPageName: string = getFeatureNameFromAppTitle(this.titleService.getTitle());
    return `${currentPageName.replace(' |', '')} | ${event}`;
  }
}
